function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-info-red") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Landing-Page"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Promo-Landing"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    d: "M21.67,25.17a.93.93,0,0,1,.91.94V28a.9.9,0,0,1-.91.9H16.33a.9.9,0,0,1-.91-.9V26.11a.9.9,0,0,1,.91-.9h.72V19.44h-.72a.89.89,0,0,1-.91-.9V16.66a.9.9,0,0,1,.91-.9H20a.9.9,0,0,1,.91.9v8.51ZM16.85,12.46a2.51,2.51,0,0,1-.14-.55,1.79,1.79,0,0,1,0-.46,1.91,1.91,0,0,1,0-.45,1.66,1.66,0,0,1,.14-.41l.2-.39a3.73,3.73,0,0,1,.28-.31c.11-.1.21-.17.35-.28a2.24,2.24,0,0,1,.38-.2h0a1.66,1.66,0,0,1,.41-.14,1.79,1.79,0,0,1,.46,0,1.91,1.91,0,0,1,.45,0,1.66,1.66,0,0,1,.41.14c.14.06.25.13.39.2s.24.18.34.28l.07.07a1.74,1.74,0,0,1,.42.63,3.74,3.74,0,0,1,.14.45,2.27,2.27,0,0,1,0,.45,2.27,2.27,0,0,1,0,.45,2.59,2.59,0,0,1-.14.45s0,0,0,.07a1,1,0,0,1-.17.35,2.16,2.16,0,0,1-.24.31l0,0a1.87,1.87,0,0,1-.31.27,2.32,2.32,0,0,1-.42.25h0a1.42,1.42,0,0,1-.38.14,2.32,2.32,0,0,1-.45,0,2.58,2.58,0,0,1-.46,0,2,2,0,0,1-.45-.14,1.21,1.21,0,0,1-.41-.21,2.75,2.75,0,0,1-.35-.31c-.07-.11-.18-.21-.25-.32S16.92,12.6,16.85,12.46ZM19,.06a19,19,0,1,1-19,19A19,19,0,0,1,19,.06Zm0,35.5A16.5,16.5,0,1,0,2.5,19.06,16.52,16.52,0,0,0,19,35.56Z",
    transform: "translate(0 -0.06)",
    style: {
      fill: "#d0021b"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoRed);
export default __webpack_public_path__ + "static/media/icon-info-red.2443b9e827b2c7a2b54eac20ce0b0381.svg";
export { ForwardRef as ReactComponent };